module.exports = __webpack_public_path__ + "img/addImgWhite.ab453f41.svg";